<!--
 * @Author: 曹捷
 * @Date: 2019-08-19 15:24:34
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-03-11 15:54:53
 * @Description: 新增角色 编辑角色 角色授权
 -->
<template>
  <a-modal class="obit-modal-default roleadd" :confirm-loading="confirmLoading" :maskClosable="false" :title="showTitle" v-model:visible="open" @cancel="closeDialog" @ok="saveInfo"
    cancelText="取消" okText="确认" width="1080px">
    <a-form :inline="true" :model="formData" :rules="rules" ref="formRef" :label-col="{span: 5}" disa :wrapper-col="{span:18}">
      <div class="drawing-board">
        <a-col :span="24">
          <p class="title bold">基础信息</p>
        </a-col>
        <a-col :span="12">
          <a-form-item label="角色名称" name="roleName">
            <a-input :maxlength="20" placeholder="请输入角色名称" show-word-limit v-model:value="formData.roleName"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="角色顺序" name="roleSort">
            <a-input-number id="inputNumber" placeholder="" v-model:value.number="formData.roleSort" :min="1" :max="999999999999999" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="权限字符" name="roleKey">
            <a-input :maxlength="20" placeholder="请输入权限字符" show-word-limit v-model:value="formData.roleKey"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="状态" name="status">
            <obit-dict dictCode="sys_normal_disable" type="radio" placeholder="请选择" v-model:value="formData.status">
            </obit-dict>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="描述" name="remark">
            <a-textarea :maxlength="100" placeholder="请输入描述" show-word-limit v-model:value="formData.remark">
            </a-textarea>
          </a-form-item>
        </a-col>
      </div>
    </a-form>
    <p class="title bold">菜单权限</p>
    <bindRolePermissVue v-if="menuLoading" ref="rolePermissRef" @save="closeDialog" :treeData="treeData" :pData="pData" :selectedKeys="selectedKeys" isMenu>
    </bindRolePermissVue>
  </a-modal>
</template>
<script>
import { computed, inject, reactive, toRefs, onMounted, toRaw } from 'vue'
import bindRolePermissVue from './bindRolePermiss.vue'
import { util } from 'obit-wui'
export default {
  components: { bindRolePermissVue },
  props: {
    open: {
      type: Boolean
    },
    addType: {
      type: String,
    },
    detailsInfo: {
      type: Object,
    },
  },
  setup (props, context) {
    let http = inject('http')
    let _data = reactive({
      formData: {},
      formRef: null,
      rolePermissRef: null,
      treeData: [],
      selectedKeys: [],
      confirmLoading: false,
      rolePmsLoading: false,
      pData: { children: 'children', title: 'label', key: 'id' },
      rules: {
        roleKey: [
          { required: true, message: '输入权限字符', trigger: 'blur' },
        ],
        roleSort: [
          { required: true, message: '输入角色顺序' },
        ],
        roleName: [
          { required: true, message: '输入角色名称', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '输入描述', trigger: 'blur' },
        ]
      },
    })
    let _computed = {
      showTitle: computed(() => props.addType === 'add' ? '添加' : '编辑'),
      menuLoading: computed(() => {
        if (props.addType === 'add') {
          return _data.treeData.length > 0
        } else {
          return _data.treeData.length > 0 && _data.rolePmsLoading
        }
      })
    }
    let _methods = {
      saveInfo () {
        _data.formRef.validate().then(() => {
          let data = util.util.cloneObj(_data.formData)
          data.menuIds = _data.rolePermissRef.getSelectKey()
          data.appId = _data.appId
          _data.confirmLoading = true
          http.saveAppRole(data, props.addType).then((res) => {
            _methods.closeDialog()
          }).catch(() => {
            _data.confirmLoading = false
          })
        })
      },
      closeDialog () {
        context.emit('reload')
        util.util.cleanObj(_data.formData)
        context.emit('update:open', false)
      },
      sysnRolePermission () {
        let list = []
        if (!props.detailsInfo.roleId) return
        let param = props.detailsInfo.roleId
        let pList = _methods.getParentList()
        http.getAppRolePermission(param).then(res => {
          if (res) {
            res.checkedKeys.forEach(element => {
              list.push(element.toString())
            })
            _data.selectedKeys = list
            _data.rolePmsLoading = true
          }
        })
      },
      getParentList () {
        let pList = []
        function findList (list) {
          list.forEach(el => {
            if (el.children && el.children.length > 0) {
              pList.push(el.id)
              findList(el.children)
            }
          })
        }
        findList(_data.treeData)
        return pList
      }
    }
    onMounted(() => {
      http.getSystemMenuTree().then(res => {
        _data.treeData = res
        if (props.addType === 'edit') {
          _data.formData = {}
          let param = props.detailsInfo.roleId
          http.getAppRoleDetail(param).then(res => {
            _data.formData = res
          })
          _methods.sysnRolePermission()
        } else {
          _data.selectedKeys = []
          _data.formData = {}
          _data.formData.status = '0'
        }
      })

    })
    return {
      ..._computed,
      ...toRefs(_data),
      ..._methods
    }
  },
}
</script>
<style lang="less">
.roleadd {
  .ant-input-number {
    width: 100%;
  }
}
</style>